var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBarChart4BarsFill = function SvgBarChart4BarsFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bar_chart_4_bars_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bar_chart_4_bars_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M3.113 19.646a.7.7 0 0 1-.512-.207.7.7 0 0 1-.206-.512q0-.305.206-.512a.7.7 0 0 1 .512-.206h16.771q.305 0 .512.206a.7.7 0 0 1 .207.513.7.7 0 0 1-.207.512.7.7 0 0 1-.512.206zm1.439-2.764q-.5 0-.849-.35a1.15 1.15 0 0 1-.35-.848v-3.465q0-.499.349-.848.349-.35.848-.35.498 0 .849.35.35.348.35.848v3.465q0 .499-.35.848-.348.35-.847.35m4.626 0q-.5 0-.85-.35a1.15 1.15 0 0 1-.35-.848V7.427q0-.498.35-.848.349-.35.847-.35.5 0 .85.35t.35.848v8.257q0 .499-.35.848-.348.35-.847.35m4.635 0q-.5 0-.85-.35a1.15 1.15 0 0 1-.35-.848v-5.382q0-.498.35-.848.348-.35.848-.35.498 0 .848.35t.35.848v5.382q0 .499-.349.848-.348.35-.847.35m4.635 0q-.5 0-.85-.35a1.15 1.15 0 0 1-.35-.848V4.552q0-.498.35-.848.349-.35.848-.35.498 0 .848.35t.35.848v11.132q0 .499-.349.848-.349.35-.847.35"
  }))));
};
export default SvgBarChart4BarsFill;